import { TextStyle, getStyledTextTokens } from "@utils/textUtils";
import { useMemo } from "react";

type Props = {
  text: string;
};

export default function TextHighlight(props: Props) {
  const tokenizedText = useMemo(() => getStyledTextTokens(props.text ?? ""), [props.text]);
  return (
    <>
      {tokenizedText.map((el, i) => {
        if (el.style == TextStyle.DEFAULT) {
          return <span key={`${el.token}-default-${i}`} dangerouslySetInnerHTML={{ __html: el.token.replaceAll("\\n", "<br />") }} />;
        } else if (el.style == TextStyle.HIGHLIGHTED) {
          return <strong key={`${el.token}-highlighted-${i}`} dangerouslySetInnerHTML={{ __html: el.token.replaceAll("\\n", "<br />") }} />;
        }
      })}
    </>
  );
}
